import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'babel-polyfill';

import Store from './redux/store';

import ProductionVis from './modules/ProductionVis/VisContainer';
import DevicesVis from './modules/DevicesVis/VisContainer';
import PrivesVis from './modules/PricesVis/VisContainer';
import ImportExportVis from './modules/ImportExportVis/VisContainer';
import Sharer from './Component/Sharer';

import './styles/main.scss';

ReactDOM.render(
  <Provider store={Store}>
    <ProductionVis />
  </Provider>,
  document.getElementById('production-vis')
);

ReactDOM.render(
  <Provider store={Store}>
    <DevicesVis />
  </Provider>,
  document.getElementById('devices-vis')
);

ReactDOM.render(
  <Provider store={Store}>
    <PrivesVis />
  </Provider>,
  document.getElementById('prices-vis')
);

ReactDOM.render(
  <Provider store={Store}>
    <ImportExportVis />
  </Provider>,
  document.getElementById('import-export-vis')
);

ReactDOM.render(
  <Sharer
    url={`${window.config.baseUrl}#production-vis-section`}
    title={window.config.labels.production_vis_sharing_title}
    description={window.config.labels.production_vis_sharing_text}
    image={`${window.config.baseUrl}assets/images/b1_prod_vis_share.png`}
  />,
  document.getElementById('production-vis-sharer')
);

ReactDOM.render(
  <Sharer
    url={`${window.config.baseUrl}#produktion-weltweit`}
    title={window.config.labels.worldmap_sharing_title}
    description={window.config.labels.worldmap_sharing_text}
    image={`${window.config.baseUrl}assets/images/b1_production_map_share.png`}
  />,
  document.getElementById('production-map-sharer')
);

ReactDOM.render(
  <Sharer
    url={`${window.config.baseUrl}#kaffee-variationen`}
    title={window.config.labels.favs_sharing_title}
    description={window.config.labels.favs_sharing_text}
    image={`${window.config.baseUrl}assets/images/b1_favs_share.png`}
  />,
  document.getElementById('favs-sharer')
);


require('./header').init();



// WEBPACK FOOTER //
// ./src/index.js